import { useMutation, useQuery } from '@tanstack/react-query';

import {
  getHotelBookingsReportJobStatus,
  queueHotelBookingsReport,
} from '~/services/ReportingService';

import { reportingQueryKeys } from './reportingQueryKeys';

const TERMINAL_STATUSES = new Set(['completed', 'failed']);

export function useQueueHotelBookingsReport() {
  return useMutation({
    mutationFn: queueHotelBookingsReport,
  });
}

export function useHotelBookingsReportJob(jobId: string | null) {
  return useQuery({
    queryKey: reportingQueryKeys.hotelBookingsJob(jobId ?? ''),
    queryFn: async ({ signal }) => {
      return await getHotelBookingsReportJobStatus(jobId!, { signal });
    },
    enabled: Boolean(jobId),
    retry: 1,
    refetchInterval: (query): number | false => {
      const status = query.state.data?.status;

      if (query.state.error) return false;
      if (!status) return 3000;

      return TERMINAL_STATUSES.has(status) ? false : 3000;
    },
  });
}
